export const validLicenses = [
    'Corporate',
    'Enterprise',
    'EnterprisePlus',
    'Trial',
    'Free',
] as const;
export type ValidLicense = (typeof validLicenses)[number];

export type NonFreeLicense = Exclude<ValidLicense, 'Free' | 'Trial'>;

export const licenseHierarchy: NonFreeLicense[] = ['Corporate', 'Enterprise', 'EnterprisePlus'];

/**
 * Maps the license name stored in the subscription to the license names coming from the feature flags
 */
export function mapSubscriptionTypeToUnleashLicense(
    license: string | null | undefined
): ValidLicense | null {
    if (license && validLicenses.includes(license as ValidLicense)) {
        return license as ValidLicense;
    }
    if (license === 'Enterprise Plus') {
        return 'EnterprisePlus';
    }
    return null;
}
